import styled from 'styled-components'
import React from 'react'
import { Chip, Grid, Typography, Button } from '@material-ui/core'
import { MigrationStatus } from '../../../../types/migration'
import RefreshIcon from '@material-ui/icons/Refresh'
import moment from 'moment'

const statusColors = {
  [MigrationStatus.QUEUED]: {
    background: '#ffe082',
    color: '#795548',
  },
  [MigrationStatus.COMPLETED]: {
    background: '#a5d6a7',
    color: '#1b5e20',
  },
  [MigrationStatus.NOT_SYNCED]: {
    background: '#ffcdd2',
    color: '#d32f2f',
  },
  [MigrationStatus.ERROR]: {
    background: '#ffcdd2',
    color: '#d32f2f',
  },
  [MigrationStatus.IN_PROGRESS]: {
    background: '#5ebcff',
    color: '#ffffff',
  },
}

const StatusChip = styled(Chip)<{ status: MigrationStatus }>`
  && {
    background-color: ${({ status }) => statusColors[status].background};
    color: ${({ status }) => statusColors[status].color};
    height: 22px;
    min-width: 100px;
  }
`

const RetryButton = styled(Button)`
  && {
    min-height: 22px;
    padding: 0 8px;
  }
`

interface MigrationChipStatusProps {
  status: MigrationStatus
  time?: number
  onRetry?: () => void
}

export const MigrationChipStatus: React.FC<MigrationChipStatusProps> = ({
  status,
  time,
  onRetry,
}) => {
  let label = ''
  switch (status) {
    case MigrationStatus.QUEUED:
      label = 'Queue'
      break
    case MigrationStatus.COMPLETED:
      label = 'Exported'
      break
    case MigrationStatus.NOT_SYNCED:
      label = 'Not exported'
      break
    case MigrationStatus.ERROR:
      label = 'Error'
      break
    case MigrationStatus.IN_PROGRESS:
      label = 'Exporting'
      break
    default:
      label = 'Unknown'
  }
  return (
    <Grid container style={{ gap: 10 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        <Grid item>
          <StatusChip status={status} label={label} />
        </Grid>
        {status === MigrationStatus.COMPLETED && (
          <Grid item>
            <Typography>
              at{' '}
              <span style={{ fontWeight: 500, fontSize: '12px' }}>
                {time && moment(time).format('MM/DD/YYYY HH:mm')}
              </span>
            </Typography>
          </Grid>
        )}
      </div>
      {status === MigrationStatus.ERROR && onRetry && (
        <Grid item>
          <RetryButton size="small" variant="contained" color="primary" onClick={onRetry}>
            <RefreshIcon style={{ color: '#fff' }} />
          </RetryButton>
        </Grid>
      )}
    </Grid>
  )
}



// WEBPACK FOOTER //
// ./src/containers/Settings/Development/MigrationChipStatus.tsx/index.tsx